<template>
  <div class="fixed-top">
    <Banner />

    <div class="bg-white p-8 menucontrol-scroll">
      <el-drawer
        :visible.sync="assignChatPopup"
        :direction="direction"
        :before-close="handleClose"
      >
        <template slot="title"
          ><h3 class="fsize16 Add mb-0 Products text-white">
            Select Recipients
          </h3></template
        >
        <Reciptiant :msg="templetemessage" @closeSlider="handleCloseSlider" />
      </el-drawer>

      <div class="w-full justify-between items-center flex">
        <div>
          <h2 class="text-dark text-2xl font-semibold">Pick a Template</h2>
          <p class="text-dark text-sm font-medium">Select layout for email</p>
        </div>
        <div class="flex gap-4 items-center">
          <vs-button
            color="primary"
            class="bg-primary text-white w-full"
            @click="handleClick('marcom')"
            >Add New</vs-button
          >
        </div>
      </div>
      <div class="mt-8 grid grid-cols-3 gap-4">
        <!-- <div @click="assignChatPopup = true" v-for="item in result">
        <img
          src="@/assets/images/new/billing.svg"
          alt="plusicon"
          class="w-full h-205px bg-fas hoverborder rounded-lg p-2 cursor-pointer"
        />
      </div> -->
        <div
          class="bg-fas hoverborder rounded-lg p-2 cursor-pointer relative"
          @click="assignChatPopup = true"
          v-for="item in result.data"
          :key="item"
        >
          <img
            src="../assets/images/backgrounds/whatsuppdoodlee.png"
            alt="plusicon"
            class="w-full h-205px relative"
          />
          <div
            @click="handleselect(item)"
            class="absolute top-0 w-full h-205px flex items-center justify-center"
          >
            <div>
              <p class="fsize12 font-normal text-center mb-3"></p>
              <div class="bg-white wid-mobiless rounded-lg p-2">
                <p class="fsize13 lineclamp-4">
                  {{ item.format }}
                </p>
                <div class="mt-2 fsize12 flex justify-end">
                  <span>
                    {{ new Date(item.updatedAt).getHours() }}:{{
                      new Date(item.updatedAt).getMinutes()
                    }}:{{ new Date(item.updatedAt).getSeconds() }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Reciptiant from "./Reciptiant.vue";
import Banner from "./BannerTemplate.vue";
export default {
  components: {
    Reciptiant,
    Banner,
  },
  data() {
    return {
      assignChatPopup: false,
      direction: "rtl",
      input: "",
      checked: "",
      result: [],
      templetemessage: "",
      uniquerecord: [],
    };
  },
  computed: {
    ...mapState("user", ["users"]),
  },
  methods: {
    async handleselect(item) {
      this.templetemessage = item.format;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async getAllTemplate() {
      this.result = await this.$store.dispatch("whatsApp/getAllTemplate");

      // console.log(this.data);
    },
    handleCloseSlider() {
      this.assignChatPopup = false;
    },
    async getAllUsers() {
      try {
        const resultt = await this.$store.dispatch("user/getAllUsers", {
          perPage: 10000,
          page: 1,
        });

        // this.perPage =
        // this.totalUsers = data.registeredUserLength;
        // this.$store.commit(
        //   "manageUser/GET_ALL_USER_DETAILS",
        //   data.registeredUser
        // );
        // this.users = data.registeredUser;
      } catch (error) {
        console.log(error);
      }
    },
  },

  async mounted() {
    await this.getAllTemplate();
    await this.getAllUsers();
    console.log(this.users, "useruseruseruser");
  },
};
</script>
